import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component visual que mostra una barra de progrés animada a la part
 * superior de la pantalla cada cop que la ruta (URL) canvia, per
 * donar la sensació de càrrega entre pàgines a la SPA.
 */
export default function TopProgressBar() {
  const location = useLocation();
  const [key, setKey] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setKey(prev => prev + 1);
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 700);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  if (!visible) return null;

  return (
    <div key={key} style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '1px',
      zIndex: 9999,
      pointerEvents: 'none'
    }}>
      <div style={{
        height: '100%',
        backgroundColor: 'var(--primary-color, #25d366)',
        width: '0%',
        animation: 'route-progress-anim 0.5s ease-out forwards'
      }} />
      <style>{`
        @keyframes route-progress-anim {
          0% { width: 0%; opacity: 1; }
          40% { width: 60%; opacity: 1; }
          80% { width: 100%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }
      `}</style>
    </div>
  );
}
